import * as React from "react"

import {
	SubheaderSwitching,
	SwitchingContainer,
	SwitchingInputValidator,
	SwitchingTree,
	SwitchingValidateData,
} from "./components"
import SwitchingBenchmarkTable from "../SwitchingBenchmarkTable/SwitchingBenchmarkTable"
import { useSetVendorFilters } from "./hooks"
import { CustomerDescriptionBase } from "components/Shared/CustomerDescription"
import { useGetErrorFilters } from "components/Shared/Filters/hooks/useGetErrorFilters"
import { collapseSideBar } from "context/applicationContext"
import { isFeatureEnabled } from "config/feature-flags"
import { SWITCHING_BENCHMARK_FLAG_ID } from "../SwitchingBenchmarkTable/constants"
import { useFiltersContext } from "components/Shared/GlobalFilter/context/filtersContext"
import { getLastSelectorWithValue } from "./utils"
import { Interval } from "components/Shared/PhronesisCalendar/PhronesisCalendar.domain"
import { getDatesFromRanges } from "components/Shared/PhronesisCalendar/PhronesisCalendar.utils"
import { SwitchingContentContainer } from "./components/SwitchingContentContainer"
import { SANKEY_SWITCHING_FLAG } from "../SankeySwitching/constants"
import SwitchingSankeyContainerRemote from "./components/SwitchingSankeyContainer/SwithcingSankeyContainerRemote"
import "./index.scss"
import { mapModuleFilters } from "components/Shared/Filters/utils"
import useConfirmedFilters from "components/Shared/Filters/hooks/useConfirmedFilters"
import { FiltersRequestButton } from "components/Shared/Filters/FiltersRequestButton"
import mandatoryFilters from "./components/SwitchingInputValidator/SwitchingValidatorConfig"

const SwitchingBreakdown: React.FC = () => {
	collapseSideBar()
	useSetVendorFilters()
	const { filters, interval } = useFiltersContext()
	const [calendarDates, setCalendarDates] = React.useState<Interval>(
		getDatesFromRanges(interval)
	)

	const {
		confirmedFilters: switchingFilters,
		calendarDateConfirmed,
		confirmFilters,
		hasFilterChangesSinceLastUpdate,
	} = useConfirmedFilters<Interval>(filters, calendarDates)
	const mappedConfirmedFilters = mapModuleFilters({
		filters: switchingFilters,
		calendarDates: calendarDateConfirmed,
	})

	const isValidFilters = !useGetErrorFilters(
		filters,
		calendarDates,
		mandatoryFilters
	)
	const isButtonRequestEnabled =
		isValidFilters && hasFilterChangesSinceLastUpdate
	const title = getLastSelectorWithValue(switchingFilters)

	const requestSwitchingReports = () => {
		confirmFilters()
	}
	const { description = "" } = getLastSelectorWithValue(switchingFilters) || {}

	return (
		<SwitchingContainer>
			<SubheaderSwitching
				onChangeCalendar={(dates) => {
					setCalendarDates(dates)
				}}
			/>
			<FiltersRequestButton
				onClick={requestSwitchingReports}
				disabled={!isButtonRequestEnabled}
				UNSAFE_className="switching_button_requester"
			/>
			<SwitchingContentContainer>
				<SwitchingInputValidator switchingFilters={mappedConfirmedFilters}>
					<SwitchingValidateData switchingFilters={mappedConfirmedFilters}>
						<CustomerDescriptionBase
							dateInterval={calendarDateConfirmed}
							filters={switchingFilters}
						/>
						<SwitchingTree
							title={title}
							switchingFilters={mappedConfirmedFilters}
						/>
						<SwitchingSankeyContainerRemote
							switchingFilters={mappedConfirmedFilters}
							isVisible={isFeatureEnabled(SANKEY_SWITCHING_FLAG)}
							levelName={description}
							title={title?.name as string}
						/>
						<SwitchingBenchmarkTable
							isVisible={isFeatureEnabled(SWITCHING_BENCHMARK_FLAG_ID)}
							fatherNodeTitle={title}
							filtersSwitching={mappedConfirmedFilters}
						/>
					</SwitchingValidateData>
				</SwitchingInputValidator>
			</SwitchingContentContainer>
		</SwitchingContainer>
	)
}

export default SwitchingBreakdown
